import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { User } from '../../interfaces/user';
import { ButtonComponent } from '../button/button.component';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { map, shareReplay, delay } from 'rxjs';
import { BuscaRedimeViveComponent } from '../busca-redime-vive/busca-redime-vive.component';
import { CountrySelectorComponent } from '../country-selector/country-selector.component';
import { CartService } from '../../services/cart.service';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService, Language } from '../../services/language.service';

import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent, FontAwesomeModule, BuscaRedimeViveComponent, CountrySelectorComponent, TranslateModule, LanguageSelectorComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnDestroy {
  isMobileMenuOpen = false;

  @Input() isHome: boolean = false;

  faInstagram = faInstagram;
  faTiktok = faTiktok;
  faFacebook = faFacebook;
  faShoppingCart = faShoppingCart;

  isAuthenticated$ = this.authService.getTokenChanges().pipe(
    map(token => !!token),
    delay(0),
    shareReplay(1)
  );

  user$ = this.authService.getUserChanges().pipe(delay(0), shareReplay(1));

  cartItemCount$ = this.cartService.getCart().pipe(
    map(items => items.reduce((count, item) => count + item.quantity, 0)),
    delay(0),
    shareReplay(1)
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private cartService: CartService,
    public languageService: LanguageService,
  ) {}

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    document.body.style.overflow = this.isMobileMenuOpen ? 'hidden' : '';
  }

  goToLogin() {
    const currentReturnUrl = this.route.snapshot.queryParams['returnUrl'];
    const currentPath = this.router.url.split('?')[0];
    const returnUrl = currentReturnUrl || currentPath;
    this.router.navigate(['login'], { queryParams: { returnUrl } });
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy() {
    document.body.style.overflow = '';
  }

  setLanguage(lang: Language) {
    this.languageService.use(lang);
  }
}
